<template>
      <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <div class="main_home_content">
    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1 pt-1 pb-5" style="margin-top: 20px;">
          <div class="home-content">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-7 col-lg-6">
                <h2 class="right_heading">
                  Patient Portal
                </h2>
                <h4 class="right_headline">
                  Your Health, Your Control
                </h4>
                <h5 class="right_content">
                  {{ main_data }} Patient Portal – A Personalized Gateway
                  to Your Healthcare Journey
                </h5>
                <p class="right_content">
                  Welcome to a new era of healthcare management, where
                  convenience, accessibility, and empowerment are at the core of
                  your experience. {{ main_data }} Patient Portal is
                  designed with you in mind, offering a secure and user-friendly
                  interface to manage all aspects of your healthcare from the
                  comfort of your home or on the go.
                </p>
                <div style="margin-top: 50px;"></div>
              </div>
              <div class="col-md-12 col-lg-6">
                <img style="height: 340px;"
                  src="@/assets/img/patientportal.jpeg"
                  class="img-fluid"
                  alt="Doccure Login"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div>
        <h2 style="text-align: center; margin-bottom: 40px;">Key Features</h2>
      </div>
    </div>
    <div>
      <div class="row mt-1">
        <div class="col-md-10 offset-md-1">
          <!-- <p><strong>Healthcare Practitioner Schedules:</strong></p> -->
          <b-card-group deck>
            <b-card
              border-variant="dark"
              header="Access Medical Records"
              header-bg-variant="dark"
              header-text-variant="white"
          
            >
              <b-card header="Your Medical History at Your Fingertips" style="border: none; ">
                <b-card-text style="font-size: 17px;"
                  >Access, view, and manage your personal medical darkrmation,
                  including diagnoses, treatment plans, lab results, and more.
                  All your health data is securely stored and readily available
                  whenever you need it.</b-card-text
                >
              </b-card>
            </b-card>
            <b-card
              border-variant="dark"
              header="Track Vital Signs"
              header-bg-variant="dark"
              header-text-variant="white"
              
            >
            <b-card header="Stay darkrmed About Your Health" style="border: none; ">
              <b-card-text
                >Categorize and organize records based on various criteria, such
                as date, type of record, medical condition, etc. This ensures
                quick retrieval and minimizes time spent searching
              </b-card-text>
            </b-card>
        </b-card>
            <b-card
              border-variant="dark"
              header="Manage Appointments:"
              header-bg-variant="dark"
              header-text-variant="white"
            
            >
            <b-card header="Schedule, Reschedule, Cancel – With Ease" style="border: none;">
              <b-card-text
                >Take control of your healthcare appointments. Whether you need
                to schedule a new appointment, reschedule an existing one, or
                cancel if something comes up – do it all effortlessly through
                the Patient Portal.</b-card-text
              >
            </b-card>
        </b-card>
          </b-card-group>
          <b-card-group deck style="margin-top: 30px;">
            <b-card
              border-variant="dark"
              header="View Prescription Details"
              header-bg-variant="dark"
              header-text-variant="white"
              style="font-size: 20px;"
            >
           
              <b-card-text style="font-size: 17px;"
                >Never lose track of your medications again. Access prescription
                darkrmation, including medication lists, dosages, and
                instructions, all neatly organized in one place." Communicate
                with Healthcare Providers::</b-card-text
              >
            
        </b-card>
            <b-card
              border-variant="dark"
              header="Direct Communication with Your Care Team"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Send and receive messages from doctors and medical staff.
                Whether you have a question, need clarification, or just want to
                discuss your care – open communication is just a click away.
              </b-card-text>
            </b-card>
            <b-card style="border: none;">
              <b-card-text></b-card-text>
            </b-card>
          </b-card-group>
        </div>
      </div>

      <h3 style="text-align: center; margin-bottom: 40px; margin-top: 60px;">
        The Future of Prescription Management
      </h3>
    </div>

    <div>
      <h4
        style="text-align: center; margin-bottom: 1px; margin-top: 20px; margin-bottom: 20px;"
      >
        Why Choose the Patient Portal ?
      </h4>
    </div>

    <div class="mt-6">
      <div>
        <div class="row mt-1">
          <div class="col-md-10 offset-md-1">
            <!-- <p><strong>Healthcare Practitioner Schedules:</strong></p> -->
            <b-card-group deck>
              <b-card
                border-variant="dark"
                header="Convenience"
                header-bg-variant="dark"
                header-text-variant="white"
                style="font-size: 20px;"
              >
                <b-card-text style="font-size: 17px;"
                  >Manage your healthcare 24/7 from any device.</b-card-text
                >
              </b-card>
              <b-card
                border-variant="dark"
                header="Transparency"
                header-bg-variant="dark"
                header-text-variant="white"
              >
                <b-card-text
                  >Full visibility into your medical history, treatments, and
                  prescriptions.
                </b-card-text>
              </b-card>
              <b-card
                border-variant="dark"
                header="Security"
                header-bg-variant="dark"
                header-text-variant="white"
              >
                <b-card-text>
                  Rest assured, your data is protected with top-notch security
                  measures.</b-card-text
                >
              </b-card>
            </b-card-group>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5"
      style="display: flex; justify-content: center; align-items: center;"
    >
      <div style="width: 500px; text-align: center;">
        <b-card bg-variant="info" text-variant="white" title="" style="border:1px solid black;">
          <b-card-text style="text-align: center;">
            "Experience the future of patient-centric healthcare with {{ main_data }}
             Patient Portal. Register today and take control of your
            health!"
          </b-card-text>
          <b-button href="#" variant="dark" style="text-align: center;">
            Register Now
          </b-button>
        </b-card>
      </div>
    </div>
  </div>
    <layout-footer></layout-footer>
    </div>
    </div>
  </template>
  
  <script>
  import config from "../../services/CommonApi";
  import axios from "axios";
  export default {
    data() {
      return {
        main_data: "",
        config: config,
      };
    },
    mounted() {
      this.get_practitioner_profile();
    },
    methods: {
  
      async get_practitioner_profile() {
        var domain = window.location.hostname;
  
        const formdata = {
          domain: window.location.hostname,
        };
        await axios
          .get(
            "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
            window.location.hostname
          )
          .then((res) => {
            this.showspinner = false;
            if (res.data.status_code == 200) {
              this.main_data = res.data.data[0].brand_name
            }
            if (res.data.status_code == 404) {
              if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
              }
              else if (window.location.hostname.startsWith("192.168")) {
              } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
              } else {
                window.location.href = String("https://physio.kneexpert.in");
              }
            }
            this.$swal.close();
          });
      },
  
    },
  }
  </script>
  
  
  
  <style>
  .right_heading {
    font-size: 40px;
    font-weight: bold;
    font-family: sans-serif;
  }
  
  .right_content {
    font-size: 16px;
    margin-top: 20px;
    font-family: sans-serif;
  }
  .right_headline {
    margin-top: 20px;
  }
  .btn {
    border-radius: 10px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/kneexpert/PatientPortal.vue